import { render, staticRenderFns } from "./ZonesEditor.vue?vue&type=template&id=47082b8a&"
import script from "./ZonesEditor.vue?vue&type=script&lang=js&"
export * from "./ZonesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports